import { GroupBase, OptionProps, components } from 'react-select';

import CountryFlag from '@creditflowresearch/uilib/CountryFlag';

import styles from '../../select.module.scss';

const OptionWithCountryFlag = <
  SOption extends { countryCode?: string },
  IsMulti extends boolean,
  Group extends GroupBase<SOption>,
>({
  children,
  ...props
}: OptionProps<SOption, IsMulti, Group>) => (
  <components.Option { ...props }>
    <CountryFlag
      className={ styles.countryFlagOption }
      countryCode={ props.data.countryCode?.toLowerCase() }
    />
    { children }
  </components.Option>
);

export default OptionWithCountryFlag;
